export const SERRANO = "#D0460B";
export const PROMO_HIGHLIGHT = "#FAEBDF";
